export default "__VITE_ASSET__Dl2Hsh99__"